module.exports = __webpack_public_path__ + "media/tutorial.820c2a45.mp4";